export const UNCONFIRM_PAYMENT                  = 'UNCONFIRM_PAYMENT';
export const UNCONFIRM_PAYMENT_FULFILLED        = 'UNCONFIRM_PAYMENT_FULFILLED';
export const UNCONFIRM_PAYMENT_PENDING          = 'UNCONFIRM_PAYMENT_PENDING';
export const UNCONFIRM_PAYMENT_REJECTED         = 'UNCONFIRM_PAYMENT_REJECTED';

export const CLEAR_UNCONFIRMED_PAYMENT          = 'CLEAR_UNCONFIRMED_PAYMENT';
export const CLEAR_ACCOUNT_RECURRENCE_ERRORS    = 'CLEAR_ACCOUNT_RECURRENCE_ERRORS';

export const HIDE_WELCOME                       = 'HIDE_WELCOME';
